<template>
  <div id="app">
    <SkipNav />

    <OfficialSite />
    <AppHeader/>
    <SystemAlert />

    <router-view v-slot="{ Component, route }">
      <transition 
        mode="out-in"
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
      >
      <div :key="route.path">
        <component :is="Component" />
      </div>
      </transition>
    </router-view>
  
    <AppFooter/>

    <!-- full screen modal -->
    <ModalAlert @modalAlertSecondaryButton="secondaryButtonClicked()"/>

    <!-- full screen spinner -->
    <ModalSpinner />
  </div>
</template>

<script setup>
import {  onMounted, } from 'vue';
import SkipNav from "@/components/SkipNav";
import OfficialSite from "@/components/OfficialSite";
import SystemAlert from '@/components/SystemAlert';
import ModalAlert from '@/components/appModal/ModalAlert';
import ModalSpinner from '@/components/appModal/ModalSpinner';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
import alertUtil from '@/utils/alerts';

onMounted(() => {
  alertUtil.hideModal();
});
</script>

<style lang="scss">
@import "~@ridmv/web-themes";
@import "~animate.css";
.animate__animated.animate__fadeOut {
  --animate-duration: .35s;
}
</style>
